module.exports = __webpack_public_path__ + "media/img/email/ic-tak-logo-946026d8b2fc2b96dcdfb762d67459f4.png";